import { render } from "./g-monaco-editor.vue?vue&type=template&id=2d7fbfd4&ts=true"
import script from "./g-monaco-editor.vue?vue&type=script&lang=tsx"
export * from "./g-monaco-editor.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__